// Shuffled order of `loading.facts` indices, computed once at app boot.
// The first two are the pair shown on /loading; the third surfaces on
// /id-card's desktop right pane so all three get airtime per session.

function shuffle<T>(arr: readonly T[]): T[] {
  const out = arr.slice();
  for (let i = out.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out;
}

export const FACT_ORDER: readonly number[] = shuffle([0, 1, 2]);
